import { z } from 'zod';
export const cdlitBookingReconciliationReasonSchema = z.enum([
    'duplicate_record_found',
    'no_record_found',
    'manual_yclients_check',
    'false_positive',
    'other',
]);
/** Allowlisted operational note codes — no free text. */
export const cdlitBookingReconciliationNoteCodeSchema = z.enum([
    'checked_yclients_ui',
    'checked_owner_call',
    'duplicate_in_crm',
    'no_record_in_crm',
    'escalated_support',
]);
export const cdlitBookingReconciliationStatusSchema = z.enum(['pending', 'reconciled']);
export const cdlitAiOpsPeriodSchema = z.enum(['today', '7d']);
export const cdlitAiOpsMetricsViewSchema = z
    .object({
    period: cdlitAiOpsPeriodSchema,
    started: z.number().int().min(0),
    recommendationShown: z.number().int().min(0),
    bookingPrepareCreated: z.number().int().min(0),
    bookingConfirmed: z.number().int().min(0),
    handoffCreated: z.number().int().min(0),
    slotConflict: z.number().int().min(0),
    outcomeUnknown: z.number().int().min(0),
    conversionRate: z.number().min(0).max(1).nullable(),
})
    .strict();
export const cdlitAiOpsReconciliationItemSchema = z
    .object({
    attemptId: z.string().uuid(),
    status: z.string(),
    failureCode: z.string().nullable(),
    reconciliationStatus: cdlitBookingReconciliationStatusSchema.nullable(),
    reconciliationReason: cdlitBookingReconciliationReasonSchema.nullable(),
    serviceExternalId: z.string(),
    staffExternalId: z.string(),
    slotStartAt: z.string().datetime(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    reconciledAt: z.string().datetime().nullable(),
})
    .strict();
export const cdlitAiOpsHandoffItemSchema = z
    .object({
    handoffId: z.string().uuid(),
    sessionId: z.string().uuid(),
    reason: z.string(),
    createdAt: z.string().datetime(),
})
    .strict();
export const cdlitAiOpsReadinessCheckSchema = z
    .object({
    id: z.string(),
    ok: z.boolean(),
    message: z.string(),
})
    .strict();
export const cdlitAiOpsReadinessViewSchema = z
    .object({
    ready: z.boolean(),
    readyForDryRun: z.boolean(),
    checks: z.array(cdlitAiOpsReadinessCheckSchema),
})
    .strict();
export const cdlitAiOpsReconcileRequestSchema = z
    .object({
    reason: cdlitBookingReconciliationReasonSchema,
    noteCode: cdlitBookingReconciliationNoteCodeSchema.optional(),
})
    .strict();
//# sourceMappingURL=ops.js.map